import { createI18n } from 'vue-i18n';
import config from './config';
import messages from './i18n'
import _mergeWith from 'lodash.mergewith'

const mergeNonEmptyValues = (defaultValue: any, overrideValue: any) => {
  if (typeof defaultValue === "string" && typeof overrideValue === "string") {
    if (overrideValue) {
      return overrideValue
    }
    return defaultValue
  }
}


const i18nConfig = createI18n({
  locale: config.language,
  fallbackLocale: 'de',
  messages: _mergeWith({}, messages, config.labelOverride, mergeNonEmptyValues)
});

export default i18nConfig;
